module.exports = __webpack_public_path__ + "img/myhy@2x.a2f9e238.png";